import React, { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import QCXFinalNumericDecimalField from '../../shared-components/final-numeric-decimal-field/QCXFinalNumericDecimalField';

export default function QCXFinalNumericDecimalFieldRender({
  disabled,
  name,
  ...restProps
}) {
  const [key, setKey] = useState(name);

  useEffect(() => {
    if (disabled) {
      setKey(`${name.replaceAll('.', '-')}-${uuid()}`);
    }
  }, [
    name,
    disabled
  ]);

  return (
    <>
      <QCXFinalNumericDecimalField
        key={key}
        name={name}
        disabled={disabled}
        {...restProps}
      />
    </>
  );
}
